import { httpCreate } from './http';

const http = httpCreate('/srv/homepage');

export const homepage = {
	homepage() {
		return http.get('');
	},
	homepagepc() {
		return http.get('/pc');
	},
	getList(id) {
		return http.get(`/list/${id}`);
	},
	create() {
		return http.post('');
	},
	editTitle(params) {
		return http.post('/title', params);
	},
	editBanner(modelId, params) {
		return http.post(`/banner/${modelId}`, params);
	},
	editImgTextModel(modelId, type, params) {
		return http.post(`/image-text-model/${modelId}?showType=${type}`, params);
	},
	addModel(name) {
		return http.post('/model', { modelType: name });
	},
	removeModel(modelId) {
		return http.delete(`/removeModel/${modelId}`);
	},
	sortModel(sortModelIds) {
		return http.post('/sort', sortModelIds);
	},
	saveSpecificModel(id, params) {
		return http.post(`/specific-model/${id}`, params);
	},
	saveOfficialModel(id, params) {
		return http.post(`/official-model/${id}`, params);
	},
	saveClassificModel(id, showType, params) {
		return http.post(`/classify-model/${id}?showType=${showType}`, params);
	},
	getShareInfo(id) {
		return http.get(`/homepage-share/${id}`);
	},
	saveShareInfo(id, data) {
		return http.post(`/homepage-share/${id}`, data);
	},
	getTitleList(userId) {
		return http.get(`/titleList/${userId}`);
	},
	getModelTitleList(homepageId) {
		return http.get(`/modelTitleList/${homepageId}`);
	},
	remove(id) {
		return http.delete(`/remove/${id}`);
	},
};
